import { render, staticRenderFns } from "./CbsForgotPasswordSetNew.vue?vue&type=template&id=060ebfda"
import script from "./CbsForgotPasswordSetNew.vue?vue&type=script&lang=js"
export * from "./CbsForgotPasswordSetNew.vue?vue&type=script&lang=js"
import style0 from "./CbsForgotPasswordSetNew.vue?vue&type=style&index=0&id=060ebfda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports